/**
 * 通话记录
 * @author fredhaochen
 */
import React, { useMemo, useState, useEffect } from 'react'
import { PageHeader } from '@components'
import { Tabs } from 'antd'
import { sessionStore } from '@store'
import QidianCallRecord from './components/QidianCallRecord'
import TCCCCallRecord from './components/TCCCCallRecord'
import MeetingCallRecord from './components/MeetingCallRecord'
import T3CCallInRecord from './components/T3CCallInRecord'
import qs from 'qs'
import { PAGE_TYPE_ENUM } from '../score-detail/constants/index'
import { moduleId } from '@configs'
import { useShallow } from 'zustand/react/shallow'

export default function CallRecordPage () {
  const { userInfo, isPermissableBelongModule } = sessionStore(
    useShallow(s => ({
      userInfo: s.userInfo,
      isPermissableBelongModule: s.isPermissableBelongModule,
    }))
  )
  const { tabKey } = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [activeKey, setActiveKey] = useState(() => {
    // 优先级：TCCC > 腾会 > 企点
    if (userInfo.useT3C) {
      return PAGE_TYPE_ENUM.T3C
    } else if (userInfo.useMeeting) {
      return PAGE_TYPE_ENUM.MEETING
    } else {
      return PAGE_TYPE_ENUM.QIDIAN
    }
  })

  // 使用useMemo优化，只有当userInfo.useT3C或userInfo.useMeeting变化时才重新计算tabItems
  const tabItems = useMemo(() => {
    const items = []

    // 当useT3C为true时，优先添加TCCC通话记录Tab
    if (userInfo.useT3C) {
      items.push({
        key: PAGE_TYPE_ENUM.T3C,
        label: 'TCCC通话记录',
        children: <TCCCCallRecord />,
      })
    }

    // 当useMeeting为true时，添加腾讯会议记录Tab（第二个位置）
    if (userInfo.useMeeting) {
      items.push({
        key: PAGE_TYPE_ENUM.MEETING,
        label: '腾会通话记录',
        children: <MeetingCallRecord />,
      })
    }

    // 始终包含企点通话记录
    items.push({
      key: PAGE_TYPE_ENUM.QIDIAN,
      label: '企点通话记录',
      children: <QidianCallRecord />,
    })

    // 电话客服-呼入记录Tab（最后一个位置，清洗模块显示）
    if (isPermissableBelongModule([moduleId.MID_LONG_TAIL_CLEAN_ID])) {
      items.push({
        key: PAGE_TYPE_ENUM.T3C_CALL_IN,
        label: '电话客服-呼入记录',
        children: <T3CCallInRecord />,
      })
    }

    return items
  }, [userInfo.useT3C, userInfo.useMeeting, userInfo.belongModule, isPermissableBelongModule])

  useEffect(() => {
    if (tabKey) {
      const tabKeyStr = tabKey as string
      const tabKeyList = tabItems.map(item => item.key)
      const flag = tabKeyList.includes(tabKeyStr as PAGE_TYPE_ENUM)
      // 优先级：TCCC > 腾会 > 企点
      let defaultKey = PAGE_TYPE_ENUM.QIDIAN
      if (userInfo.useT3C) {
        defaultKey = PAGE_TYPE_ENUM.T3C
      } else if (userInfo.useMeeting) {
        defaultKey = PAGE_TYPE_ENUM.MEETING
      }
      setActiveKey(flag ? tabKeyStr as PAGE_TYPE_ENUM : defaultKey)
      const urlObj = new URL(location.href)
      urlObj.searchParams.delete('tabKey')
      window.history.replaceState({}, '', urlObj.toString())
    }
  }, [tabKey, tabItems, userInfo.useT3C, userInfo.useMeeting])

  return (
    <PageHeader title="通话记录" footer={(
      <Tabs
        activeKey={activeKey}
        items={tabItems}
        onChange={key => {
          setActiveKey(key as PAGE_TYPE_ENUM)
        }}
      />
    )} />
  )
}
